import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const CHANGE_AUCTION_BET = 'AUCTION :: CHANGE_AUCTION_BET';

export type TChangeAuctionBetAction = IReduxAction<typeof CHANGE_AUCTION_BET>;

export const changeAuctionBet = actionGenerator<typeof CHANGE_AUCTION_BET>(CHANGE_AUCTION_BET);
